export const isFilterReady = (filter, orgCode, groupId, terminalSerial) => {
  const hasValue = value => String(value ?? "").trim().length > 0
  switch (filter) {
    case "F_ORG_CODE": return hasValue(orgCode)
    case "F_GRP_ID": return hasValue(orgCode) && hasValue(groupId)
    case "F_TRMNL_SERIAL": return hasValue(terminalSerial)
    default: return false
  }
}
